//maybe something in here that changes the active one each section?
export function boot() {
  let navContainer = document.querySelector('#menu-container');
  let navTop = navContainer.offsetTop;
  const mobileSticker = document.querySelector('.mobile_sticker');
  const xIcon = document.querySelector('.LATClose01');
  const menuIcon = document.querySelector('.LATMenu');
  const mobileNav = document.querySelector('.mobile-nav-holder');

  var stick = function () {
    if (window.pageYOffset >= navTop) {
      navContainer.classList.add('sticky');
      //navContainer.style.position = 'sticky';
      mobileSticker.style.display = 'flex';
      $('.mobile-nav-holder').hide();
      $('.LATClose01').hide();
      $('.LATMenu').show();
    } else {
      navContainer.classList.remove('sticky');
      $('.LATClose01').show();
      $('.LATMenu').hide();
      //navContainer.style.position = 'relative';
      mobileSticker.style.display = 'none';
      $('.mobile-nav-holder').show();
    }
  };

  //calll it once to make sure if the page is loaded halfway down and no scrolling has been done, we'll still see a shadow on load
  //stick();

  //call stick on scroll to make sure we can add / remove appropriately
  window.onscroll = () => stick();

  //let menuActive = 1;
  $('.mobile_sticker').on('click', function () {
    $('.LATClose01').toggle();
    $('.LATMenu').toggle();
    $('.mobile-nav-holder').slideToggle();
    //let menuActive =  menuActive + 1;
  });

  //perhaps additional logic for if you click a nav item inside mobile sticker also toggle.

  function mediaQuery(x) {
    if (x.matches) {
      navTop = navTop - 45;
    } else {
      navTop = navTop;
    }
  }

  var mq = window.matchMedia('(max-width: 767px)');
  mediaQuery(mq);
  mq.addListener(mediaQuery);
}
